<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="8">
        <a-button type="primary" @click="openModel">添加供应商</a-button>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align: right;">
        <a-button @click="goRules">同步规则</a-button>
      </a-col>
    </a-row>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <span slot="statusSlots" slot-scope="rowItem">
        <span>{{ rowItem.record.status == 1 ? '启用' : '禁用' }}</span>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status==0" @click="onUpdateEvent(rowItem.record.id,1)">启用</a>
        <a v-else @click="onUpdateEvent(rowItem.record.id,0)">禁用</a>
      </span>
    </custom-page-table>
    <a-modal title="添加供应商" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口地址" prop="supplierUrl">
          <a-input v-model.trim="ruleForm.supplierUrl" placeholder="接口地址" :maxLength="300"></a-input>
        </a-form-model-item>
        <a-form-model-item label="OTA账号" prop="supplierAccount">
          <a-input v-model.trim="ruleForm.supplierAccount" placeholder="OTA账号" :maxLength="300"></a-input>
        </a-form-model-item>
        <a-form-model-item label="OTA密钥" prop="supplierKey">
          <a-input v-model.trim="ruleForm.supplierKey" placeholder="OTA密钥" :maxLength="300"></a-input>
        </a-form-model-item>
        <a-form-model-item label="景区编码" prop="supplierSpotsCode">
          <a-input v-model.trim="ruleForm.supplierSpotsCode" placeholder="景区编码" :maxLength="300"></a-input>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">提交</a-button>
        </div>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'GalasysNewAccount',
  data() {
    return {
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '接口地址',
          dataIndex: 'supplierUrl'
        },
        {
          title: 'OTA账号',
          dataIndex: 'supplierAccount'
        },
        {
          title: '景区编码',
          dataIndex: 'supplierSpotsCode'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusSlots' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '110px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      visible: false,
      submitLoading: false,
      ruleForm: {
        id: 0,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        supplierName: '',//供应商名称
        supplierUrl: '',//供应商接口地址
        supplierAccount: '',//供应商OTA账号
        supplierSpotsCode: '',//供应商景区编码
        supplierKey: ''//供应商OTA密钥
      },
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        supplierUrl: [{ required: true, message: '请输入接口地址', trigger: 'blur' }],
        supplierAccount: [{ required: true, message: '请输入OTA账号', trigger: 'blur' }],
        supplierKey: [{ required: true, message: '请输入OTA密钥', trigger: 'blur' }],
        supplierSpotsCode: [{ required: true, message: '请输入景区编码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GalasysConnection', title: '商品绑定' },
      { name: 'GalasysOrderConnection', title: '订单直连' },
      { name: 'GalasysNewAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getServerApiService().post('galasys/supplier/list', params)
    },
    //启禁用事件
    onUpdateEvent(id, status) {
      let params = {
        id: id,
        status: status,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      this.getHttpServices().getServerApiService().post('galasys/supplier/status', params).then(res => {
        this.$refs.table.refresh(true)
        this.$message.success('状态更新成功')
      }).catch(err => {
        this.getLogUtils().logWithTag('onUpdateEvent', err)
      })
    },
    //编辑事件
    editEvent(item) {
      this.ruleForm = item
      this.visible = true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('galasys/supplier/add', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('数据更新成功')
        this.visible = false
        this.resetFrom()
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.visible = true
    },
    resetFrom() {
      this.ruleForm = {
        id: 0,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        supplierName: '',//供应商名称
        supplierUrl: '',//供应商接口地址
        supplierAccount: '',//供应商OTA账号
        supplierSpotsCode: '',//供应商景区编码
        supplierKey: ''//供应商OTA密钥
      }
    },
    handleCancel() {
      this.visible = false
    },
    goRules() {
      this.$router.push({
        name: 'GalasysAsyncRule',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>
<style scoped></style>
